export function showSlidesInImageCarousel(n, slideIndex: number) {
  let slides = document.getElementsByClassName("mySlides");
  var count = slides.length;

  if (count <= 3) return;

  slideIndex += n;

  if (slideIndex < 0) slideIndex = count + slideIndex;

  slideIndex = slideIndex % count;

  var endIndex = (slideIndex + 3) % count;

  for (let i = 0; i < count; i++) {
    slides[i].classList.add("hide");
  }

  for (let i = slideIndex; i != endIndex; i = (i + 1) % count) {
    console.log("showing", i);
    slides[i].classList.remove("hide");
  }
  return slideIndex;
}
